import React from "react";
import { AppRoutes } from "../routes/AppRoutes";

// Dynamic Sensor Dashboard
const DynamicSensorDashboard = React.lazy(
  () => import("../pages/Dashboard/SensorDashboard/DynamicSensorDashboard"),
);

// DASHBOARD
const Dashboard = React.lazy(() => import("../pages/Dashboard"));

//RULES
const AddEditRules = React.lazy(() => import("../pages/Rules/AddEdit.jsx"));

//RELAYS
const Relays = React.lazy(() => import("../pages/Relays/arduino"));

// LOGS -ACCESS
const AccessLogsList = React.lazy(() => import("../pages/Logs/Access/List"));

// LOGS -ADMINISTRATIVE
const AdministrativeLogsList = React.lazy(
  () => import("../pages/Logs/Administrative/List"),
);

// LOGS -DEVICE
const DeviceLogsList = React.lazy(() => import("../pages/Logs/Device/List"));

// LOGS - ACTIVITY
const ListAcitivityLogs = React.lazy(
  () => import("../pages/Logs/ActivityLogs/List"),
);

// LOGS - AUDIT

const LogsAuditList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Audit/List"),
);

// LOGS - AUTHENTICATION
const ListAuthenticationLogs = React.lazy(
  () => import("../pages/Logs/AuthenticationLogs/List"),
);
// LOGS - SESSION

const LogsSessionList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Session/List"),
);

// LOGS - DEVICE

const LogsDeviceList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Device/List"),
);

// LOGS - GATEWAY

const LogsGatewayList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Gateway/List"),
);
// LOGS - MQTT

const LogsMqttList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Mqtt/List"),
);

// LOGS - API

const LogsApiList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Api/List"),
);

// LOGS - SYSTEM

const LogsSystemList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/System/List"),
);

// LOGS - SYSLOG

const LogsSyslogList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Syslog/List"),
);

// LOGS - ACCESS

const LogsAccessList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Access/List"),
);

// LOGS - ADMINISTRATIVE

const LogsAdministrativeList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Logs/Administrative/List"),
);

//AREA
const AreaMap = React.lazy(() => import("../pages/Area/pages/Map"));
const AreaList = React.lazy(() => import("../pages/Area/pages/List"));
const AddEditArea = React.lazy(() => import("../pages/Area/pages/AddEdit"));

// LOCATION
const LocationList = React.lazy(() => import("../pages/Location/List"));
const AddEditLocation = React.lazy(() => import("../pages/Location/AddEdit"));

//SITES
const SiteList = React.lazy(() => import("../pages/Sites/List"));
const AddEditSite = React.lazy(() => import("../pages/Sites/AddEdit"));
const SiteDashboard = React.lazy(() => import("../pages/Sites/SiteDashboard"));

// ADMINISTRATION - ROLES
const RolesList = React.lazy(
  () => import("../pages/Administration/Roles/List"),
);
const AddEditRoles = React.lazy(
  () => import("../pages/Administration/Roles/AddEdit"),
);

// ADMINISTRATION - ORGANIZATIONS
const OrganizationsList = React.lazy(
  () => import("../pages/Administration/Organizations/List"),
);
const AddEditOrganizations = React.lazy(
  () => import("../pages/Administration/Organizations/AddEdit"),
);


// ADMINISTRATION - USERS
const UserList = React.lazy(() => import("../pages/Administration/User/List"));
const AddEditUser = React.lazy(
  () => import("../pages/Administration/User/AddEdit"),
);
const PasswordChange = React.lazy(
  () => import("../pages/Administration/User/PasswordChange"),
);
const UpdateProfile = React.lazy(
  () => import("../pages/Administration/User/UpdateProfile"),
);

// CONFIGURATION - CATEGORIES
const CategoryList = React.lazy(
  () => import("../pages/Configuration/DeviceCategories/List"),
);
const AddEditCategory = React.lazy(
  () => import("../pages/Configuration/DeviceCategories/AddEdit"),
);

// CONFIGURATION - LIBRARY
const LibraryList = React.lazy(
  () => import("../pages/Configuration/DeviceLibrary/List"),
);
const AddEditLibrary = React.lazy(
  () => import("../pages/Configuration/DeviceLibrary/AddEdit"),
);

// CONFIGURATION - FEATURES
const FeatureList = React.lazy(
  () => import("../pages/Configuration/DeviceFeatures/List"),
);
const AddEditFeature = React.lazy(
  () => import("../pages/Configuration/DeviceFeatures/AddEdit"),
);

// CONFIGURATION - FEATURE GROUP
const FeatureGroupList = React.lazy(
  () => import("../pages/Configuration/FeatureGroup/List"),
);
const AddEditFeatureGroup = React.lazy(
  () => import("../pages/Configuration/FeatureGroup/AddEdit"),
);

// CONFIGURATION - THRESHOLD PROFILE
const DeviceThresholdList = React.lazy(
  () => import("../pages/Configuration/DeviceThreshold/List"),
);
const AddEditDeviceThreshold = React.lazy(
  () => import("../pages/Configuration/DeviceThreshold/AddEdit"),
);

// CONFIGURATION - THRESHOLD GROUP
const ThresholdGroupList = React.lazy(
  () => import("../pages/Configuration/ThresholdGroup/List"),
);
const AddEditThresholdGroup = React.lazy(
  () => import("../pages/Configuration/ThresholdGroup/AddEdit"),
);

// CONFIGURATION - RELAY PROFILES
const RelayProfilesList = React.lazy(
  () => import("../pages/Configuration/RelayProfiles/List"),
);
const AddEditRelayProfiles = React.lazy(
  () => import("../pages/Configuration/RelayProfiles/AddEdit"),
);

// CONFIGURATION - DEVICE TYPE
const DeviceTypeList = React.lazy(
  () => import("../pages/Configuration/DeviceType/List"),
);
const AddEditDeviceType = React.lazy(
  () => import("../pages/Configuration/DeviceType/AddEdit"),
);

// CONFIGURATION - DASHBOARD TEMPLATE
const ListDeviceDashboardTemplate = React.lazy(
  () => import("../pages/Configuration/DashboardTemplate/List"),
);
const AddEditDeviceDashboardTemplate = React.lazy(
  () => import("../pages/Configuration/DashboardTemplate/AddEdit"),
);

//CATALOG - MANUFACTURERS
const DeviceManufacturersList = React.lazy(
  () => import("../pages/Catalog/DeviceManufacturers/List"),
);
const AddEditDeviceManufacturers = React.lazy(
  () => import("../pages/Catalog/DeviceManufacturers/AddEdit"),
);

//CATALOG - DEVICE TAGS
const DeviceTagsList = React.lazy(
  () => import("../pages/Catalog/DeviceTags/List"),
);
const AddEditDeviceTags = React.lazy(
  () => import("../pages/Catalog/DeviceTags/AddEdit"),
);

//CATALOG - DEVICE MODEL
const DeviceModelList = React.lazy(
  () => import("../pages/Catalog/DeviceModel/List"),
);
const AddEditDeviceModel = React.lazy(
  () => import("../pages/Catalog/DeviceModel/AddEdit"),
);

//CATALOG - Device HWversion
const DeviceHWVersionList = React.lazy(
  () => import("../pages/Catalog/DeviceHWVersion/List"),
);
const AddEditDeviceHWVersion = React.lazy(
  () => import("../pages/Catalog/DeviceHWVersion/AddEdit"),
);

//CATALOG - PROTOCOLS
const ProtocolsList = React.lazy(
  () => import("../pages/Catalog/Protocol/List"),
);
const AddEditProtocols = React.lazy(
  () => import("../pages/Catalog/Protocol/AddEdit"),
);

//CATALOG - UNITS
const UnitsList = React.lazy(() => import("../pages/Catalog/Unit/List"));
const AddEditUnits = React.lazy(() => import("../pages/Catalog/Unit/AddEdit"));

//CATALOG - DATA FORMAT
const DataFormatList = React.lazy(
  () => import("../pages/Catalog/DataFormat/List"),
);
const AddEditDataFormat = React.lazy(
  () => import("../pages/Catalog/DataFormat/AddEdit"),
);

//CATALOG - DATA TYPE
const DataTypeList = React.lazy(() => import("../pages/Catalog/DataType/List"));
const AddEditDataType = React.lazy(
  () => import("../pages/Catalog/DataType/AddEdit"),
);

//METADATA - FIELD DICTIONARY
const FieldDictionaryList = React.lazy(
  () => import("../pages/Metadata/FieldDictionary/List"),
);
const AddEditFieldDictionary = React.lazy(
  () => import("../pages/Metadata/FieldDictionary/AddEdit"),
);

//METADATA - FIELD GROUP
const FieldGroupList = React.lazy(
  () => import("../pages/Metadata/FieldGroup/List"),
);
const AddEditFieldGroup = React.lazy(
  () => import("../pages/Metadata/FieldGroup/AddEdit"),
);

//DEVICE - ONBOARDING
const DeviceOnboardingList = React.lazy(
  () => import("../pages/Device/Onboarding/List"),
);
const AddEditDeviceOnboarding = React.lazy(
  () => import("../pages/Device/Onboarding/AddEdit"),
);

// DEVICE - INVENTORY

const DeviceInventoryList = React.lazy(
  // () => import("../layout/UnderDevelopmentPage"),
  () => import("../pages/Device/Inventory/List"),
);

const AddEditDeviceInventory = React.lazy(
  // () => import("../layout/UnderDevelopmentPage"),
  () => import("../pages/Device/Inventory/AddEdit"),
);

// DEVICE - PROFILES

const DeviceProfilesList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Device/Profiles/List"),
);

const AddEditDeviceProfiles = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Device/Profiles/AddEdit"),
);


//TRACKING - DEVICES
const DeviceTracking = React.lazy(
  () => import("../pages/Tracking/DeviceTracking"),
);

//TRACKING - ASSETS
const CoTracking = React.lazy(() => import("../pages/Tracking/CoTracking"));
const CoTrackingDetails = React.lazy(
  () => import("../pages/Tracking/CoTrackingDetails"),
);

// TRACKING - GATEWAYS

const GatewayTracking = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Tracking/GatewayTracking"),
);

// TRACKING - LOCATION HISTORY

const TrackingLocationHistoryList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Tracking/LocationHistory/List"),
);

// TRACKING - GEOFENCING

const TrackingGeofencingList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Tracking/Geofencing/List"),
);


//GATEWAYS - ONBOARDING
const GatewayOnboardingList = React.lazy(
  () => import("../pages/Gateway/Onboarding/List"),
);
const AddEditGatewayOnboarding = React.lazy(
  () => import("../pages/Gateway/Onboarding/AddEdit"),
);

//GATEWAYS - PROFILES
const GatewayProfileList = React.lazy(
  () => import("../pages/Gateway/GatewayProfile/List"),
);
const AddEditGatewayProfile = React.lazy(
  () => import("../pages/Gateway/GatewayProfile/AddEdit"),
);

// GATEWAYS - INVENTORY

const GatewayInventoryList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Gateway/Inventory/List"),
);

const AddEditGatewayInventory = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Gateway/Inventory/AddEdit"),
);


// ESL - DASHBOARD
const ESLDashboard = React.lazy(
  () => import("../pages/Minew/EslDashboardOverview"),
);


//ESL - STORE DATA
const StoreDataList = React.lazy(() => import("../pages/Minew/StoreData/List"));
const AddEditStoreData = React.lazy(() => import('../pages/Minew/StoreData/AddEdit'));

//ESL -STORE FIELD
const StoreFieldList = React.lazy(
  () => import("../pages/Minew/StoreField/List"),
);

//ESL - DEVICE
const DeviceList = React.lazy(() => import("../pages/Minew/Device/List"));
const AddEditDevice = React.lazy(() => import("../pages/Minew/Device/AddEdit"));

//ESL - GATEWAY
const GatewayList = React.lazy(() => import("../pages/Minew/Gateway/List"));
const AddEditGateway = React.lazy(() => import("../pages/Minew/Gateway/AddEdit"));

//ESL - Template
const TemplateList = React.lazy(() => import("../pages/Minew/Template/List"));

// //SERVICES - EMAIL
// const EmailList = React.lazy(() => import('../pages/Services/List'));
// const AddEditEmail = React.lazy(() => import('../pages/Services/Email/AddEdit'));

// //SERVICES - TELEGRAM
// const TelegramList = React.lazy(() => import('../pages/Services/List'));
// const AddEditTelegram = React.lazy(() => import('../pages/Services/Telegram/AddEdit'));

// //SERVICES - SMS
// const SmsList = React.lazy(() => import('../pages/Services/List'));
// const AddEditSms = React.lazy(() => import('../pages/Services/Sms/AddEdit'));

// //SERVICES - WHATSAPP
// const WhatsAppList = React.lazy(() => import('../pages/Services/List'));
// const AddEditWhatsApp = React.lazy(() => import('../pages/Services/Whatsapp/AddEdit'));

// //SERVICES - WEBHOOK
// const WebhookList = React.lazy(() => import('../pages/Services/List'));
// const AddEditWebhook = React.lazy(() => import('../pages/Services/Webhook/AddEdit'));

// //SERVICES - PUSH NOTIFICATION
// const PushNotificationList = React.lazy(() => import('../pages/Services/List'));
// const AddEditPushNotification = React.lazy(() => import('../pages/Services/Other/AddEdit'));

// SYSTEM - DATE TIME

const AddEditDateTime = React.lazy(
  () => import("../pages/System/DateTime/AddEdit"),
);
// SYSTEM - MAINTENANCE

const SystemMaintenance = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/System/Maintenance"),
);

// SYSTEM - BACKUP RESTORE

const SystemBackupRestoreList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/System/BackupRestore/List"),
);

const AddEditSystemBackupRestore = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/System/BackupRestore/AddEdit"),
);

// SYSTEM - CLUSTER

const SystemCluster = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/System/Cluster"),
);

// SYSTEM - MONITORING

const SystemMonitoring = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/System/Monitoring"),
);

// SYSTEM - LICENSE

const SystemLicenseList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/System/License/List"),
);

// SERVICES - EMAIL
const EmailList = React.lazy(() => import("../pages/Services/Email/List"));

const AddEditEmail = React.lazy(
  () => import("../pages/Services/Email/AddEdit"),
);

// SERVICES - TELEGRAM
const TelegramList = React.lazy(
  () => import("../pages/Services/Telegram/List"),
);

const AddEditTelegram = React.lazy(
  () => import("../pages/Services/Telegram/AddEdit"),
);

// SERVICES - SMS
const SmsList = React.lazy(() => import("../pages/Services/Sms/List"));

const AddEditSms = React.lazy(() => import("../pages/Services/Sms/AddEdit"));

// SERVICES - WHATSAPP
const WhatsAppList = React.lazy(
  () => import("../pages/Services/Whatsapp/List"),
);

const AddEditWhatsApp = React.lazy(
  () => import("../pages/Services/Whatsapp/AddEdit"),
);

// SERVICES - WEBHOOK
const WebhookList = React.lazy(() => import("../pages/Services/Webhook/List"));

const AddEditWebhook = React.lazy(
  () => import("../pages/Services/Webhook/AddEdit"),
);

// SERVICES - PUSH NOTIFICATION
const PushNotificationList = React.lazy(
  () => import("../pages/Services/Other/List"),
);

const AddEditPushNotification = React.lazy(
  () => import("../pages/Services/Other/AddEdit"),
);

// RFID - DASHBOARD
const RfidDashboard = React.lazy(
  () => import("../pages/Rfid/EdgeDevice/RfidDashboardOverview"),
);


// RFID - CARDS
const RfidCardList = React.lazy(
  () => import("../pages/Rfid/Card/List"),
);

const AddEditRfidCard = React.lazy(
  () => import("../pages/Rfid/Card/AddEdit"),
);

// RFID - EDGE DEVICES
const RfidEdgeDeviceList = React.lazy(
  () => import("../pages/Rfid/EdgeDevice/List"),
);

const RfidEdgeDeviceDetails = React.lazy(
  () => import("../pages/Rfid/EdgeDevice/DeviceDetail"),
);

const AddEditRfidEdgeDevice = React.lazy(
  () => import("../pages/Rfid/EdgeDevice/AddEdit"),
);

// // RFID - READERS
const RfidReaderList = React.lazy(
  () => import("../pages/Rfid/Reader/List"),
);

const AddEditRfidReader = React.lazy(
  () => import("../pages/Rfid/Reader/AddEdit"),
);

// RFID - SCHEDULES
const RfidScheduleList = React.lazy(
  () => import("../pages/Rfid/Schedule/List"),
);

const AddEditRfidSchedule = React.lazy(
  () => import("../pages/Rfid/Schedule/AddEdit"),
);

// RFID - ACCESS POLICIES
const RfidAccessPolicyList = React.lazy(
  () => import("../pages/Rfid/AccessPolicy/List"),
);

const AddEditRfidAccessPolicy = React.lazy(
  () => import("../pages/Rfid/AccessPolicy/AddEdit"),
);

// // RFID - EDGE COMMANDS
// const RfidEdgeCommandList = React.lazy(
//   () => import("../pages/Rfid/EdgeCommand/List"),
// );

// const AddEditRfidEdgeCommand = React.lazy(
//   () => import("../pages/Rfid/EdgeCommand/AddEdit"),
// );

// // RFID - ACCESS LOGS
// const RfidAccessLogList = React.lazy(
//   () => import("../pages/Rfid/AccessLog/List"),
// );

// // RFID - HEALTH HISTORY
// const RfidHealthHistoryList = React.lazy(
//   () => import("../pages/Rfid/HealthHistory/List"),
// );

// // RFID - STATUS HISTORY
// const RfidStatusHistoryList = React.lazy(
//   () => import("../pages/Rfid/StatusHistory/List"),
// );

// // RFID - SYNC HISTORY
// const RfidSyncHistoryList = React.lazy(
//   () => import("../pages/Rfid/SyncHistory/List"),
// );

// MONITORING - DASHBOARD
const MonitoringDashboardView = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Monitoring/Dashboard"),
);

// MONITORING - GATEWAY HEALTH
const MonitoringGatewayHealthView = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Monitoring/GatewayHealth"),
);

// MONITORING - DEVICE HEALTH
const MonitoringDeviceHealthView = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Monitoring/DeviceHealth"),
);

// MONITORING - LIVE DEVICES
const MonitoringLiveDevicesView = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Monitoring/LiveDevices"),
);

// ALERTS - ACTIVE

const AlertsActiveList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Active/List"),
);

// ALERTS - RULES

const AlertsRulesList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Rules/List"),
);

const AddEditAlertsRules = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Rules/AddEdit"),
);

// ALERTS - PROFILES

const AlertsProfilesList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Profiles/List"),
);

const AddEditAlertsProfiles = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Profiles/AddEdit"),
);

// ALERTS - NOTIFICATIONS

const AlertsNotificationsList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Notifications/List"),
);

const AddEditAlertsNotifications = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Notifications/AddEdit"),
);

// ALERTS - ESCALATION

const AlertsEscalationList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Escalation/List"),
);

const AddEditAlertsEscalation = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/Escalation/AddEdit"),
);

// ALERTS - HISTORY

const AlertsHistoryList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/History/List"),
);

// ALERTS - MAINTENANCE WINDOW

const AlertsMaintenanceWindowList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/MaintenanceWindow/List"),
);

const AddEditAlertsMaintenanceWindow = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Alerts/MaintenanceWindow/AddEdit"),
);

// EVENTS - LIVE

const EventsLiveList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Live/List"),
);

// EVENTS - HISTORY

const EventsHistoryList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/History/List"),
);

// EVENTS - RULES

const EventsRulesList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Rules/List"),
);

const AddEditEventsRules = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Rules/AddEdit"),
);

// EVENTS - CATEGORIES

const EventsCategoriesList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Categories/List"),
);

const AddEditEventsCategories = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Categories/AddEdit"),
);

// EVENTS - CORRELATION

const EventsCorrelationList = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Correlation/List"),
);

const AddEditEventsCorrelation = React.lazy(
  () => import("../layout/UnderDevelopmentPage"),
  // () => import("../pages/Events/Correlation/AddEdit"),
);

//=========Front User========

const routes = [
  //DASHBOARD
  {
    path: AppRoutes.DASHBOARD.INDEX,
    name: "Dashboard",
    element: Dashboard,
  },


  // ESL - DASHBOARD
  {
    path: AppRoutes.ESL.DASHBOARD.INDEX,
    name: "ESL Dashboard",
    element: ESLDashboard,
  },


  //ESL - DEVICE
  {
    path: AppRoutes.ESL.DEVICE.LIST,
    name: "Device List",
    element: DeviceList,
  },

    //ESL - DEVICE
  {
    path: AppRoutes.ESL.DEVICE.ADD_EDIT,
    name: "Add/Edit Device",
    element: AddEditDevice,
  },


  //ESL - GATEWAY
  {
    path: AppRoutes.ESL.GATEWAY.LIST,
    name: "Add/Edit Gateway",
    element: GatewayList,
  },
  {
    path: AppRoutes.ESL.GATEWAY.ADD_EDIT,
    name: "Gateway List",
    element: AddEditGateway,
  },

  //ESL - Store Template
  {
    path: AppRoutes.ESL.STORE_TEMPLATE.LIST,
    name: "Store Template List",
    element: TemplateList,
  },

  //ESL -STORE DATA
  {
    path: AppRoutes.ESL.CONTENT.LIST,
    name: "Content List",
    element: StoreDataList,
  },
  {
    path: AppRoutes.ESL.CONTENT.ADD_EDIT,
    name: "Add/Edit Content",
    element: AddEditStoreData,
  },


  //ESL -FIELD
  {
    path: AppRoutes.ESL.STORE_FIELD.LIST,
    name: "Store Field List",
    element: StoreFieldList,
  },

  //GATEWAYS - ONBOARDING
  {
    path: AppRoutes.GATEWAYS.ONBOARDING.LIST,
    name: "Gateway Onboarding List",
    element: GatewayOnboardingList,
  },
  {
    path: AppRoutes.GATEWAYS.ONBOARDING.ADD_EDIT,
    name: "Add/Edit Gateway Onboarding",
    element: AddEditGatewayOnboarding,
  },
  //GATEWAYS - PROFILES
  {
    path: AppRoutes.GATEWAYS.PROFILES.LIST,
    name: "Gateway Profile List",
    element: GatewayProfileList,
  },
  {
    path: AppRoutes.GATEWAYS.PROFILES.ADD_EDIT,
    name: "Add/Edit Gateway Profile",
    element: AddEditGatewayProfile,
  },

  // GATEWAYS - INVENTORY
  {
    path: AppRoutes.GATEWAYS.INVENTORY.LIST,
    name: "Gateway Inventory",
    element: GatewayInventoryList,
  },

  {
    path: AppRoutes.GATEWAYS.INVENTORY.ADD_EDIT,
    name: "Add Edit Gateway Inventory",
    element: AddEditGatewayInventory,
  },

  //TRACKING - DEVICES
  {
    path: AppRoutes.TRACKING.DEVICES.LIST,
    name: "Tracking Devices List",
    element: DeviceTracking,
  },
  //TRACKING - ASSETS
  {
    path: AppRoutes.TRACKING.ASSETS.LIST,
    name: "Tracking Assets List",
    element: CoTracking,
  },

  //TRACKING - Co ASSETS
  // {
  //     path: AppRoutes.TRACKING.ASSETS.LIST,
  //     name: 'Co - Tracking Assets List',
  //     element: CoTrackingDetails,
  // },
  // TRACKING - GATEWAYS

  {
    path: AppRoutes.TRACKING.GATEWAYS.LIST,
    name: "Gateway Tracking",
    element: GatewayTracking,
  },

  // TRACKING - LOCATION HISTORY

  {
    path: AppRoutes.TRACKING.LOCATION_HISTORY.LIST,
    name: "Location History",
    element: TrackingLocationHistoryList,
  },

  // TRACKING - GEOFENCING

  {
    path: AppRoutes.TRACKING.GEOFENCING.LIST,
    name: "Geofencing",
    element: TrackingGeofencingList,
  },

  //DEVICE - ONBOARDING
  {
    path: AppRoutes.DEVICES.ONBOARDING.LIST,
    name: "Device Onboarding List",
    element: DeviceOnboardingList,
  },
  {
    path: AppRoutes.DEVICES.ONBOARDING.ADD_EDIT,
    name: "Add/Edit Device Onboarding",
    element: AddEditDeviceOnboarding,
  },
  // DEVICE - INVENTORY

  {
    path: AppRoutes.DEVICES.INVENTORY.LIST,
    name: "Device Inventory",
    element: DeviceInventoryList,
  },

  {
    path: AppRoutes.DEVICES.INVENTORY.ADD_EDIT,
    name: "Add Edit Device Inventory",
    element: AddEditDeviceInventory,
  },

  // DEVICE - PROFILES

  {
    path: AppRoutes.DEVICES.PROFILES.LIST,
    name: "Device Profiles",
    element: DeviceProfilesList,
  },

  {
    path: AppRoutes.DEVICES.PROFILES.ADD_EDIT,
    name: "Add Edit Device Profile",
    element: AddEditDeviceProfiles,
  },

  //METADATA - FIELD DICTIONARY
  {
    path: AppRoutes.METADATA.FIELD_DICTIONARY.LIST,
    name: "Field Dictionary List",
    element: FieldDictionaryList,
  },
  {
    path: AppRoutes.METADATA.FIELD_DICTIONARY.ADD_EDIT,
    name: "Add/Edit Field Dictionary",
    element: AddEditFieldDictionary,
  },
  //METADATA - FIELD GROUP
  {
    path: AppRoutes.METADATA.FIELD_GROUPS.LIST,
    name: "Field Group List",
    element: FieldGroupList,
  },
  {
    path: AppRoutes.METADATA.FIELD_GROUPS.ADD_EDIT,
    name: "Add/Edit Field Group",
    element: AddEditFieldGroup,
  },
  //CATALOG - MANUFACTURERS
  {
    path: AppRoutes.CATALOG.MANUFACTURERS.LIST,
    name: "Device Manufacturers List",
    element: DeviceManufacturersList,
  },
  {
    path: AppRoutes.CATALOG.MANUFACTURERS.ADD_EDIT,
    name: "Add/Edit Device Manufacturers",
    element: AddEditDeviceManufacturers,
  },
  //CATALOG - DEVICE TAGS
  {
    path: AppRoutes.CATALOG.DEVICE_TAGS.LIST,
    name: "Device Tags List",
    element: DeviceTagsList,
  },
  {
    path: AppRoutes.CATALOG.DEVICE_TAGS.ADD_EDIT,
    name: "Add/Edit Device Tags",
    element: AddEditDeviceTags,
  },
  //CATALOG - DEVICE MODEL
  {
    path: AppRoutes.CATALOG.DEVICE_MODELS.LIST,
    name: "Device Model List",
    element: DeviceModelList,
  },
  {
    path: AppRoutes.CATALOG.DEVICE_MODELS.ADD_EDIT,
    name: "Add/Edit Device Model",
    element: AddEditDeviceModel,
  },
  //CATALOG - Device HWversion
  {
    path: AppRoutes.CATALOG.HARDWARE_VERSIONS.LIST,
    name: "Device HWversion List",
    element: DeviceHWVersionList,
  },
  {
    path: AppRoutes.CATALOG.HARDWARE_VERSIONS.ADD_EDIT,
    name: "Add/Edit Device HWversion",
    element: AddEditDeviceHWVersion,
  },

  //CATALOG - PROTOCOLS
  {
    path: AppRoutes.CATALOG.PROTOCOLS.LIST,
    name: "Protocols List",
    element: ProtocolsList,
  },
  {
    path: AppRoutes.CATALOG.PROTOCOLS.ADD_EDIT,
    name: "Add/Edit Protocols",
    element: AddEditProtocols,
  },

  // CONFIGURATION - CATEGORIES
  {
    path: AppRoutes.CONFIGURATION.CATEGORIES.LIST,
    name: "Categories List",
    element: CategoryList,
  },
  {
    path: AppRoutes.CONFIGURATION.CATEGORIES.ADD_EDIT,
    name: "Add/Edit Category",
    element: AddEditCategory,
  },
  // CONFIGURATION - LIBRARY
  {
    path: AppRoutes.CONFIGURATION.LIBRARIES.LIST,
    name: "Library List",
    element: LibraryList,
  },
  {
    path: AppRoutes.CONFIGURATION.LIBRARIES.ADD_EDIT,
    name: "Add/Edit Library",
    element: AddEditLibrary,
  },
  // CONFIGURATION - FEATURES
  {
    path: AppRoutes.CONFIGURATION.FEATURES.LIST,
    name: "Feature List",
    element: FeatureList,
  },
  {
    path: AppRoutes.CONFIGURATION.FEATURES.ADD_EDIT,
    name: "Add/Edit Feature",
    element: AddEditFeature,
  },
  // CONFIGURATION - THRESHOLD GROUP
  {
    path: AppRoutes.CONFIGURATION.THRESHOLD_GROUPS.LIST,
    name: "Threshold Group List",
    element: ThresholdGroupList,
  },
  {
    path: AppRoutes.CONFIGURATION.THRESHOLD_GROUPS.ADD_EDIT,
    name: "Add/Edit Threshold Group",
    element: AddEditThresholdGroup,
  },
  // CONFIGURATION - RELAY PROFILES
  {
    path: AppRoutes.CONFIGURATION.RELAY_PROFILES.LIST,
    name: "Relay Profiles List",
    element: RelayProfilesList,
  },
  {
    path: AppRoutes.CONFIGURATION.RELAY_PROFILES.ADD_EDIT,
    name: "Add/Edit Relay Profiles",
    element: AddEditRelayProfiles,
  },

  // ADMINISTRATION - ROLES
  {
    path: AppRoutes.ADMINISTRATION.ROLES.LIST,
    name: "Roles List",
    element: RolesList,
  },
  {
    path: AppRoutes.ADMINISTRATION.ROLES.ADD_EDIT,
    name: "Add/Edit Roles",
    element: AddEditRoles,
  },

  // ADMINISTRATION - USERS

  {
    path: AppRoutes.ADMINISTRATION.USERS.LIST,
    name: "User List",
    element: UserList,
  },
  {
    path: AppRoutes.ADMINISTRATION.USERS.ADD_EDIT,
    name: "Add/Edit User",
    element: AddEditUser,
  },
  {
    path: AppRoutes.ADMINISTRATION.USERS.FORCE_CHANGE_PASSWORD,
    name: "Force Change Password",
    element: PasswordChange,
  },
  {
    path: AppRoutes.ADMINISTRATION.USERS.UPDATE_PROFILE,
    name: "Update Profile",
    element: UpdateProfile,
  },

  // SERVICES - EMAIL
  {
    path: AppRoutes.SERVICES.EMAIL.LIST,
    name: "Email List",
    element: EmailList,
  },
  {
    path: AppRoutes.SERVICES.EMAIL.ADD_EDIT,
    name: "Add/Edit Email",
    element: AddEditEmail,
  },

  // SERVICES - TELEGRAM
  {
    path: AppRoutes.SERVICES.TELEGRAM.LIST,
    name: "Telegram List",
    element: TelegramList,
  },
  {
    path: AppRoutes.SERVICES.TELEGRAM.ADD_EDIT,
    name: "Add/Edit Telegram",
    element: AddEditTelegram,
  },

  //SERVICES - SMS
  {
    path: AppRoutes.SERVICES.SMS.LIST,
    name: "Sms List",
    element: SmsList,
  },
  {
    path: AppRoutes.SERVICES.SMS.ADD_EDIT,
    name: "Add/Edit Sms",
    element: AddEditSms,
  },

  //SERVICES - WHATSAPP
  {
    path: AppRoutes.SERVICES.WHATSAPP.LIST,
    name: "WhatsApp List",
    element: WhatsAppList,
  },
  {
    path: AppRoutes.SERVICES.WHATSAPP.ADD_EDIT,
    name: "Add/Edit WhatsApp",
    element: AddEditWhatsApp,
  },

  //SERVICES - WEBHOOK
  {
    path: AppRoutes.SERVICES.WEBHOOK.LIST,
    name: "Webhook List",
    element: WebhookList,
  },
  {
    path: AppRoutes.SERVICES.WEBHOOK.ADD_EDIT,
    name: "Add/Edit Webhook",
    element: AddEditWebhook,
  },

  //SERVICES - PUSH NOTIFICATION
  {
    path: AppRoutes.SERVICES.WEBHOOK.LIST,
    name: "Push Notification List",
    element: PushNotificationList,
  },
  {
    path: AppRoutes.SERVICES.WEBHOOK.ADD_EDIT,
    name: "Add/Edit Push Notification",
    element: AddEditPushNotification,
  },

  //SITES
  {
    path: AppRoutes.FACILITIES.SITES.DASHBOARD,
    name: "Sites Dashboard",
    element: SiteDashboard,
  },
  {
    path: AppRoutes.FACILITIES.SITES.LIST,
    name: "Sites List",
    element: SiteList,
  },
  {
    path: AppRoutes.FACILITIES.SITES.ADD_EDIT,
    name: "Add/Edit Sites",
    element: AddEditSite,
  },

  //LOCATION
  {
    path: AppRoutes.FACILITIES.LOCATION.LIST,
    name: "Location List",
    element: LocationList,
  },
  {
    path: AppRoutes.FACILITIES.LOCATION.ADD_EDIT,
    name: "Add/Edit Location",
    element: AddEditLocation,
  },

  //AREA
  {
    path: AppRoutes.FACILITIES.AREA.MAP,
    name: "Area Map",
    element: AreaMap,
  },
  {
    path: AppRoutes.FACILITIES.AREA.LIST,
    name: "Area List",
    element: AreaList,
  },
  {
    path: AppRoutes.FACILITIES.AREA.ADD_EDIT,
    name: "Add/Edit Area",
    element: AddEditArea,
  },

  // LOGS -ACCESS
  {
    path: AppRoutes.LOGS.ACCESS.LIST,
    name: "Access Logs",
    element: AccessLogsList,
  },
  // LOGS -ADMINISTRATIVE

  {
    path: AppRoutes.LOGS.ADMINISTRATIVE.LIST,
    name: "Administrative Logs",
    element: AdministrativeLogsList,
  },

  // LOGS -DEVICE
  {
    path: AppRoutes.LOGS.DEVICE.LIST,
    name: "Device Logs",
    element: DeviceLogsList,
  },

  //RELAYS
  {
    path: AppRoutes.CONFIGURATION.RELAYS.INDEX,
    name: "Relays Dashboard",
    element: Relays,
  },

  // {
  //     path: AppRoutes.CONFIGURATION.RELAYS.LIST,
  //     name: 'Relays List',
  //     element: "",
  // },

  // {
  //     path: AppRoutes.CONFIGURATION.RELAYS.ADD_EDIT,
  //     name: 'Add/Edit Relays',
  //     element: "",
  // },

  //CATALOG - UNITS
  {
    path: AppRoutes.CATALOG.UNITS.LIST,
    name: "Units List",
    element: UnitsList,
  },
  {
    path: AppRoutes.CATALOG.UNITS.ADD_EDIT,
    name: "Add/Edit Units",
    element: AddEditUnits,
  },

  //CATALOG - DATA FORMAT
  {
    path: AppRoutes.CATALOG.DATA_FORMATS.LIST,
    name: "Data Format List",
    element: DataFormatList,
  },
  {
    path: AppRoutes.CATALOG.DATA_FORMATS.ADD_EDIT,
    name: "Add/Edit Data Format",
    element: AddEditDataFormat,
  },

  //CATALOG - DATA TYPE
  {
    path: AppRoutes.CATALOG.DATA_TYPES.LIST,
    name: "Data Type List",
    element: DataTypeList,
  },
  {
    path: AppRoutes.CATALOG.DATA_TYPES.ADD_EDIT,
    name: "Add/Edit Data Type",
    element: AddEditDataType,
  },

  // CONFIGURATION - CATEGORIES
  {
    path: AppRoutes.CONFIGURATION.CATEGORIES.LIST,
    name: "Categories List",
    element: CategoryList,
  },
  {
    path: AppRoutes.CONFIGURATION.CATEGORIES.ADD_EDIT,
    name: "Add/Edit Category",
    element: AddEditCategory,
  },
  // CONFIGURATION - LIBRARY
  {
    path: AppRoutes.CONFIGURATION.LIBRARIES.LIST,
    name: "Library List",
    element: LibraryList,
  },
  {
    path: AppRoutes.CONFIGURATION.LIBRARIES.ADD_EDIT,
    name: "Add/Edit Library",
    element: AddEditLibrary,
  },
  // CONFIGURATION - FEATURES
  {
    path: AppRoutes.CONFIGURATION.FEATURES.LIST,
    name: "Feature List",
    element: FeatureList,
  },
  {
    path: AppRoutes.CONFIGURATION.FEATURES.ADD_EDIT,
    name: "Add/Edit Feature",
    element: AddEditFeature,
  },
  // CONFIGURATION - FEATURE GROUP

  {
    path: AppRoutes.CONFIGURATION.FEATURE_GROUPS.LIST,
    name: "Feature Group List",
    element: FeatureGroupList,
  },
  {
    path: AppRoutes.CONFIGURATION.FEATURE_GROUPS.ADD_EDIT,
    name: "Add/Edit Feature Group",
    element: AddEditFeatureGroup,
  },

  // CONFIGURATION - FEATURE GROUP
  {
    path: AppRoutes.CONFIGURATION.DEVICE_THRESHOLD.LIST,
    name: "Device Threshold List",
    element: DeviceThresholdList,
  },
  {
    path: AppRoutes.CONFIGURATION.DEVICE_THRESHOLD.ADD_EDIT,
    name: "Add/Edit Device Threshold",
    element: AddEditDeviceThreshold,
  },

  // CONFIGURATION - THRESHOLD GROUP
  {
    path: AppRoutes.CONFIGURATION.THRESHOLD_GROUPS.LIST,
    name: "Threshold Group List",
    element: ThresholdGroupList,
  },
  {
    path: AppRoutes.CONFIGURATION.THRESHOLD_GROUPS.ADD_EDIT,
    name: "Add/Edit Threshold Group",
    element: AddEditThresholdGroup,
  },

  // CONFIGURATION - RELAY PROFILES
  {
    path: AppRoutes.CONFIGURATION.RELAY_PROFILES.LIST,
    name: "Relay Profiles List",
    element: RelayProfilesList,
  },
  {
    path: AppRoutes.CONFIGURATION.RELAY_PROFILES.ADD_EDIT,
    name: "Add/Edit Relay Profiles",
    element: AddEditRelayProfiles,
  },

  // CONFIGURATION - DEVICE TYPE
  {
    path: AppRoutes.CONFIGURATION.DEVICE_TYPES.LIST,
    name: "Device Type List",
    element: DeviceTypeList,
  },
  {
    path: AppRoutes.CONFIGURATION.DEVICE_TYPES.ADD_EDIT,
    name: "Add/Edit Device Type",
    element: AddEditDeviceType,
  },

  // CONFIGURATION - DASHBOARD TEMPLATE
  {
    path: AppRoutes.CONFIGURATION.DASHBOARD_TEMPLATE.LIST,
    name: "Dashboard Template List",
    element: ListDeviceDashboardTemplate,
  },
  {
    path: AppRoutes.CONFIGURATION.DASHBOARD_TEMPLATE.ADD_EDIT,
    name: "Dashboard Template AddEdit",
    element: AddEditDeviceDashboardTemplate,
  },
  {
    path: `${AppRoutes.CONFIGURATION.DASHBOARD_TEMPLATE.ADD_EDIT}/:id`,
    name: "Dashboard Template Edit",
    element: AddEditDeviceDashboardTemplate,
  },

  // ADMINISTRATION - ROLES
  {
    path: AppRoutes.ADMINISTRATION.ROLES.LIST,
    name: "Roles List",
    element: RolesList,
  },
  {
    path: AppRoutes.ADMINISTRATION.ROLES.ADD_EDIT,
    name: "Add/Edit Roles",
    element: AddEditRoles,
  },

  // ADMINISTRATION - ORGANIZATIONS
  {
    path: AppRoutes.ADMINISTRATION.ORGANIZATIONS.LIST,
    name: "Organizations List",
    element: OrganizationsList,
  },
  {
    path: AppRoutes.ADMINISTRATION.ORGANIZATIONS.ADD_EDIT,
    name: "Add/Edit Organizations",
    element: AddEditOrganizations,
  },

  // ADMINISTRATION - USERS
  {
    path: AppRoutes.ADMINISTRATION.USERS.LIST,
    name: "User List",
    element: UserList,
  },
  {
    path: AppRoutes.ADMINISTRATION.USERS.ADD_EDIT,
    name: "Add/Edit User",
    element: AddEditUser,
  },
  {
    path: AppRoutes.ADMINISTRATION.USERS.FORCE_CHANGE_PASSWORD,
    name: "Force Change Password",
    element: PasswordChange,
  },
  {
    path: AppRoutes.ADMINISTRATION.USERS.UPDATE_PROFILE,
    name: "Update Profile",
    element: UpdateProfile,
  },

  // SERVICES - EMAIL
  {
    path: AppRoutes.SERVICES.EMAIL.LIST,
    name: "Email List",
    element: EmailList,
  },
  {
    path: AppRoutes.SERVICES.EMAIL.ADD_EDIT,
    name: "Add/Edit Email",
    element: AddEditEmail,
  },

  // SERVICES - TELEGRAM
  {
    path: AppRoutes.SERVICES.TELEGRAM.LIST,
    name: "Telegram List",
    element: TelegramList,
  },
  {
    path: AppRoutes.SERVICES.TELEGRAM.ADD_EDIT,
    name: "Add/Edit Telegram",
    element: AddEditTelegram,
  },

  //SERVICES - SMS
  {
    path: AppRoutes.SERVICES.SMS.LIST,
    name: "Sms List",
    element: SmsList,
  },
  {
    path: AppRoutes.SERVICES.SMS.ADD_EDIT,
    name: "Add/Edit Sms",
    element: AddEditSms,
  },

  //SERVICES - WHATSAPP
  {
    path: AppRoutes.SERVICES.WHATSAPP.LIST,
    name: "WhatsApp List",
    element: WhatsAppList,
  },
  {
    path: AppRoutes.SERVICES.WHATSAPP.ADD_EDIT,
    name: "Add/Edit WhatsApp",
    element: AddEditWhatsApp,
  },

  //SERVICES - WEBHOOK
  {
    path: AppRoutes.SERVICES.WEBHOOK.LIST,
    name: "Webhook List",
    element: WebhookList,
  },
  {
    path: AppRoutes.SERVICES.WEBHOOK.ADD_EDIT,
    name: "Add/Edit Webhook",
    element: AddEditWebhook,
  },

  //SERVICES - PUSH NOTIFICATION
  //   {
  //     path: AppRoutes.SERVICES.WEBHOOK.LIST,
  //     name: "Push Notification List",
  //     element: PushNotificationList,
  //   },
  //   {
  //     path: AppRoutes.SERVICES.WEBHOOK.ADD_EDIT,
  //     name: "Add/Edit Push Notification",
  //     element: AddEditPushNotification,
  //   },

  // SERVICES - PUSH NOTIFICATION
  {
    path: AppRoutes.SERVICES.PUSH_NOTIFICATION.LIST,
    name: "Push Notification List",
    element: PushNotificationList,
  },
  {
    path: AppRoutes.SERVICES.PUSH_NOTIFICATION.ADD_EDIT,
    name: "Add/Edit Push Notification",
    element: AddEditPushNotification,
  },

  //SITES
  {
    path: AppRoutes.FACILITIES.SITES.DASHBOARD,
    name: "Sites Dashboard",
    element: SiteDashboard,
  },
  {
    path: AppRoutes.FACILITIES.SITES.LIST,
    name: "Sites List",
    element: SiteList,
  },
  {
    path: AppRoutes.FACILITIES.SITES.ADD_EDIT,
    name: "Add/Edit Sites",
    element: AddEditSite,
  },

  //LOCATION
  {
    path: AppRoutes.FACILITIES.LOCATION.LIST,
    name: "Location List",
    element: LocationList,
  },
  {
    path: AppRoutes.FACILITIES.LOCATION.ADD_EDIT,
    name: "Add/Edit Location",
    element: AddEditLocation,
  },

  //AREA
  {
    path: AppRoutes.FACILITIES.AREA.MAP,
    name: "Area Map",
    element: AreaMap,
  },
  {
    path: AppRoutes.FACILITIES.AREA.LIST,
    name: "Area List",
    element: AreaList,
  },
  {
    path: AppRoutes.FACILITIES.AREA.ADD_EDIT,
    name: "Add/Edit Area",
    element: AddEditArea,
  },

  // LOGS -ACCESS
  {
    path: AppRoutes.LOGS.ACCESS.LIST,
    name: "Access Logs",
    element: AccessLogsList,
  },
  // LOGS -ADMINISTRATIVE

  {
    path: AppRoutes.LOGS.ADMINISTRATIVE.LIST,
    name: "Administrative Logs",
    element: AdministrativeLogsList,
  },

  // LOGS -DEVICE
  {
    path: AppRoutes.LOGS.DEVICE.LIST,
    name: "Device Logs",
    element: DeviceLogsList,
  },

  //RELAYS
  {
    path: AppRoutes.CONFIGURATION.RELAYS.INDEX,
    name: "Relays Dashboard",
    element: Relays,
  },

  // {
  //     path: AppRoutes.CONFIGURATION.RELAYS.LIST,
  //     name: 'Relays List',
  //     element: "",
  // },

  // {
  //     path: AppRoutes.CONFIGURATION.RELAYS.ADD_EDIT,
  //     name: 'Add/Edit Relays',
  //     element: "",
  // },

  //RULES
  // {
  //     path: AppRoutes.RULES.LIST,
  //     name: 'Rules List',
  //     element: "",
  // },
  {
    path: AppRoutes.RULES.ADD_EDIT,
    name: "Add/Edit Rules",
    element: AddEditRules,
  },
  //SENSOR DASHBOARD
  {
    path: AppRoutes.SENSOR_DASHBOARD.PATH,
    name: "Sensor Dashboard",
    element: DynamicSensorDashboard,
  },
  // LOGS - ACTIVITY
  {
    path: AppRoutes.LOGS.ACTIVITY.LIST,
    name: "Activity Logs",
    element: ListAcitivityLogs,
  },
  // LOGS - AUDIT
  {
    path: AppRoutes.LOGS.AUDIT.LIST,
    name: "Audit Logs",
    element: LogsAuditList,
  },

  // LOGS - AUTHENTICATION
  {
    path: AppRoutes.LOGS.AUTHENTICATION.LIST,
    name: "Authentication Logs",
    element: ListAuthenticationLogs,
  },
  // LOGS - SESSION

  {
    path: AppRoutes.LOGS.SESSION.LIST,
    name: "Session Logs",
    element: LogsSessionList,
  },

  // LOGS - DEVICE

  {
    path: AppRoutes.LOGS.DEVICE.LIST,
    name: "Device Logs",
    element: LogsDeviceList,
  },

  // LOGS - GATEWAY

  {
    path: AppRoutes.LOGS.GATEWAY.LIST,
    name: "Gateway Logs",
    element: LogsGatewayList,
  },
  // LOGS - MQTT

  {
    path: AppRoutes.LOGS.MQTT.LIST,
    name: "MQTT Logs",
    element: LogsMqttList,
  },

  // LOGS - API

  {
    path: AppRoutes.LOGS.API.LIST,
    name: "API Logs",
    element: LogsApiList,
  },

  // LOGS - SYSTEM

  {
    path: AppRoutes.LOGS.SYSTEM.LIST,
    name: "System Logs",
    element: LogsSystemList,
  },
  // LOGS - SYSLOG

  {
    path: AppRoutes.LOGS.SYSLOG.LIST,
    name: "Syslog",
    element: LogsSyslogList,
  },

  // LOGS - ACCESS

  {
    path: AppRoutes.LOGS.ACCESS.LIST,
    name: "Access Logs",
    element: LogsAccessList,
  },

  // LOGS - ADMINISTRATIVE

  {
    path: AppRoutes.LOGS.ADMINISTRATIVE.LIST,
    name: "Administrative Logs",
    element: LogsAdministrativeList,
  },

  //SYSTEM - DATE TIME
  {
    path: AppRoutes.SYSTEM.DATE_TIME.ADD_EDIT,
    name: "Add/Edit DateTime",
    element: AddEditDateTime,
  },
  // SYSTEM - MAINTENANCE

  {
    path: AppRoutes.SYSTEM.MAINTENANCE.INDEX,
    name: "Maintenance",
    element: SystemMaintenance,
  },

  // SYSTEM - BACKUP RESTORE

  {
    path: AppRoutes.SYSTEM.BACKUP_RESTORE.LIST,
    name: "Backup & Restore",
    element: SystemBackupRestoreList,
  },

  {
    path: AppRoutes.SYSTEM.BACKUP_RESTORE.ADD_EDIT,
    name: "Add Edit Backup & Restore",
    element: AddEditSystemBackupRestore,
  },

  // SYSTEM - CLUSTER

  {
    path: AppRoutes.SYSTEM.CLUSTER.INDEX,
    name: "Cluster Settings",
    element: SystemCluster,
  },

  // SYSTEM - MONITORING

  {
    path: AppRoutes.SYSTEM.MONITORING.INDEX,
    name: "System Monitoring",
    element: SystemMonitoring,
  },

  // SYSTEM - LICENSE

  {
    path: AppRoutes.SYSTEM.LICENSE.LIST,
    name: "License",
    element: SystemLicenseList,
  },


  // RFID - DASHBOARD
  {
    path: AppRoutes.RFID.DASHBOARD.INDEX,
    name: "RFID Dashboard",
    element: RfidDashboard,
  },

  // RFID - CARDS
  {
    path: AppRoutes.RFID.CARDS.LIST,
    name: "RFID Card List",
    element: RfidCardList,
  },
  {
    path: AppRoutes.RFID.CARDS.ADD_EDIT,
    name: "Add/Edit RFID Card",
    element: AddEditRfidCard,
  },

  // RFID - EDGE DEVICES
  {
    path: AppRoutes.RFID.EDGE_DEVICES.LIST,
    name: "RFID Edge Device List",
    element: RfidEdgeDeviceList,
  },
  {
    path: AppRoutes.RFID.EDGE_DEVICES.ADD_EDIT,
    name: "Add/Edit RFID Edge Device",
    element: AddEditRfidEdgeDevice,
  },
  {
    path: AppRoutes.RFID.EDGE_DEVICES.DETAILS,
    name: "RFID Edge Device Details",
    element: RfidEdgeDeviceDetails,
  },

  // RFID - READERS
  {
    path: AppRoutes.RFID.READERS.LIST,
    name: "RFID Reader List",
    element: RfidReaderList,
  },
  {
    path: AppRoutes.RFID.READERS.ADD_EDIT,
    name: "Add/Edit RFID Reader",
    element: AddEditRfidReader,
  },

  // RFID - SCHEDULES
  {
    path: AppRoutes.RFID.SCHEDULES.LIST,
    name: "RFID Schedule List",
    element: RfidScheduleList,
  },
  {
    path: AppRoutes.RFID.SCHEDULES.ADD_EDIT,
    name: "Add/Edit RFID Schedule",
    element: AddEditRfidSchedule,
  },

  // RFID - ACCESS POLICIES
  {
    path: AppRoutes.RFID.ACCESS_POLICIES.LIST,
    name: "RFID Access Policy List",
    element: RfidAccessPolicyList,
  },
  {
    path: AppRoutes.RFID.ACCESS_POLICIES.ADD_EDIT,
    name: "Add/Edit RFID Access Policy",
    element: AddEditRfidAccessPolicy,
  },

  // // RFID - EDGE COMMANDS
  // {
  //   path: AppRoutes.RFID.EDGE_COMMANDS.LIST,
  //   name: "RFID Edge Command List",
  //   element: RfidEdgeCommandList,
  // },
  // {
  //   path: AppRoutes.RFID.EDGE_COMMANDS.ADD_EDIT,
  //   name: "Add/Edit RFID Edge Command",
  //   element: AddEditRfidEdgeCommand,
  // },

  // // RFID - ACCESS LOGS
  // {
  //   path: AppRoutes.RFID.ACCESS_LOGS.LIST,
  //   name: "RFID Access Log List",
  //   element: RfidAccessLogList,
  // },

  // // RFID - HEALTH HISTORY
  // {
  //   path: AppRoutes.RFID.HEALTH_HISTORY.LIST,
  //   name: "RFID Health History List",
  //   element: RfidHealthHistoryList,
  // },

  // // RFID - STATUS HISTORY
  // {
  //   path: AppRoutes.RFID.STATUS_HISTORY.LIST,
  //   name: "RFID Status History List",
  //   element: RfidStatusHistoryList,
  // },

  // // RFID - SYNC HISTORY
  // {
  //   path: AppRoutes.RFID.SYNC_HISTORY.LIST,
  //   name: "RFID Sync History List",
  //   element: RfidSyncHistoryList,
  // },

  // MONITORING - DASHBOARD
  {
    path: AppRoutes.MONITORING.DASHBOARD.INDEX,
    name: "Monitoring Dashboard",
    element: MonitoringDashboardView,
  },

  // MONITORING - LIVE DEVICES
  {
    path: AppRoutes.MONITORING.LIVE_DEVICES.LIST,
    name: "Live Devices",
    element: MonitoringLiveDevicesView,
  },

  // MONITORING - GATEWAY HEALTH
  {
    path: AppRoutes.MONITORING.GATEWAY_HEALTH.LIST,
    name: "Gateway Health",
    element: MonitoringGatewayHealthView,
  },

  // MONITORING - DEVICE HEALTH
  {
    path: AppRoutes.MONITORING.DEVICE_HEALTH.LIST,
    name: "Device Health",
    element: MonitoringDeviceHealthView,
  },

  // ALERTS - ACTIVE

  {
    path: AppRoutes.ALERTS.ACTIVE.LIST,
    name: "Active Alerts",
    element: AlertsActiveList,
  },

  // ALERTS - RULES

  {
    path: AppRoutes.ALERTS.RULES.LIST,
    name: "Alert Rules",
    element: AlertsRulesList,
  },

  {
    path: AppRoutes.ALERTS.RULES.ADD_EDIT,
    name: "Add Edit Alert Rule",
    element: AddEditAlertsRules,
  },

  // ALERTS - PROFILES

  {
    path: AppRoutes.ALERTS.PROFILES.LIST,
    name: "Alert Profiles",
    element: AlertsProfilesList,
  },

  {
    path: AppRoutes.ALERTS.PROFILES.ADD_EDIT,
    name: "Add Edit Alert Profile",
    element: AddEditAlertsProfiles,
  },

  // ALERTS - NOTIFICATIONS

  {
    path: AppRoutes.ALERTS.NOTIFICATIONS.LIST,
    name: "Alert Notifications",
    element: AlertsNotificationsList,
  },

  {
    path: AppRoutes.ALERTS.NOTIFICATIONS.ADD_EDIT,
    name: "Add Edit Alert Notification",
    element: AddEditAlertsNotifications,
  },

  // ALERTS - ESCALATION

  {
    path: AppRoutes.ALERTS.ESCALATION.LIST,
    name: "Alert Escalation",
    element: AlertsEscalationList,
  },

  {
    path: AppRoutes.ALERTS.ESCALATION.ADD_EDIT,
    name: "Add Edit Alert Escalation",
    element: AddEditAlertsEscalation,
  },

  // ALERTS - HISTORY

  {
    path: AppRoutes.ALERTS.HISTORY.LIST,
    name: "Alert History",
    element: AlertsHistoryList,
  },

  // ALERTS - MAINTENANCE WINDOW

  {
    path: AppRoutes.ALERTS.MAINTENANCE_WINDOW.LIST,
    name: "Maintenance Windows",
    element: AlertsMaintenanceWindowList,
  },

  {
    path: AppRoutes.ALERTS.MAINTENANCE_WINDOW.ADD_EDIT,
    name: "Add Edit Maintenance Window",
    element: AddEditAlertsMaintenanceWindow,
  },

  // EVENTS - LIVE
  {
    path: AppRoutes.EVENTS.LIVE.LIST,
    name: "Live Events",
    element: EventsLiveList,
  },

  // EVENTS - HISTORY

  {
    path: AppRoutes.EVENTS.HISTORY.LIST,
    name: "Event History",
    element: EventsHistoryList,
  },

  // EVENTS - RULES

  {
    path: AppRoutes.EVENTS.RULES.LIST,
    name: "Event Rules",
    element: EventsRulesList,
  },

  {
    path: AppRoutes.EVENTS.RULES.ADD_EDIT,
    name: "Add Edit Event Rule",
    element: AddEditEventsRules,
  },

  // EVENTS - CATEGORIES

  {
    path: AppRoutes.EVENTS.CATEGORIES.LIST,
    name: "Event Categories",
    element: EventsCategoriesList,
  },

  {
    path: AppRoutes.EVENTS.CATEGORIES.ADD_EDIT,
    name: "Add Edit Event Category",
    element: AddEditEventsCategories,
  },

  // EVENTS - CORRELATION

  {
    path: AppRoutes.EVENTS.CORRELATION.LIST,
    name: "Event Correlation",
    element: EventsCorrelationList,
  },

  {
    path: AppRoutes.EVENTS.CORRELATION.ADD_EDIT,
    name: "Add Edit Event Correlation",
    element: AddEditEventsCorrelation,
  },

]
export default routes
